import React, { VFC, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  FormGroup,
  TextField,
} from "@mui/material";
import { useEffect } from "react";
import { Validation } from "@validation";
import LabelRequired from "components/atoms/LabelRequired";

export interface IWreckerEditData {
  wrecker_name: string;
}

interface IWreckerEditProps {
  data: IWreckerEditData;
  open: boolean;
  onClose: Function;
  onChange: Function;
}

const WreckerEditDialog: VFC<IWreckerEditProps> = ({
  data,
  open,
  onClose,
  onChange,
}: IWreckerEditProps) => {
  // ------------------------------------------------------------------
  // 初期化
  // ------------------------------------------------------------------
  const [wreckerName, setWreckerName] = useState("");
  const [errorText, setErrorText] = useState("");
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    const setInitialData = async () => {
      setWreckerName(data.wrecker_name);
      setErrorText("");
      setDisabled(true);
    };

    if (open) {
      setInitialData();
    }
  }, [open, data]);

  // ------------------------------------------------------------------
  // 入力
  // ------------------------------------------------------------------
  const changeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWreckerName(e.target.value);
  };

  const validName = () => {
    const error_text = Validation.validate({
      type: "text",
      name: "名称",
      value: wreckerName,
      required: true,
      max_length: 20,
    });
    setErrorText(error_text);
    setDisabled(error_text.length > 0 || data.wrecker_name == wreckerName);
  };

  return (
    <Dialog
      maxWidth="sm"
      sx={{ "& .MuiDialog-paper": { width: "80%" } }}
      open={open}
    >
      <DialogContent>
        <FormGroup>
          <TextField
            label={
              <>
                <LabelRequired title={"名称"} />
              </>
            }
            value={wreckerName}
            onChange={changeName}
            onBlur={validName}
            error={errorText.length > 0}
            helperText={errorText}
            inputProps={{
              maxLength: 20,
            }}
          />
        </FormGroup>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          onClick={() => {
            onClose();
          }}
          variant="outlined"
        >
          キャンセル
        </Button>

        <Button
          onClick={() => {
            const response: IWreckerEditData = {
              wrecker_name: wreckerName,
            };
            onChange(response);
            onClose();
          }}
          disabled={disabled}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WreckerEditDialog;
